export default {
  name: 'print-template',
  translationKey: 'print-template-module',
  routePrefix: 'print-template',
  routeNamePrefix: 'admin.print-template',
  directRoutesAvailable: false,
}
